import { Stack } from '@mantine/core';

import { ComponentChatPromo } from 'components/component-chat/components/ComponentChatPromo';
import { SubscriptionOnboardingButton } from 'components/subscriptions/SubscriptionOnboardingButton';

const RequestAccess = () => {
    return (
        <ComponentChatPromo showDemo={true}>
            <Stack gap="xs" style={{ alignSelf: 'stretch' }}>
                <SubscriptionOnboardingButton>Upgrade</SubscriptionOnboardingButton>
            </Stack>
        </ComponentChatPromo>
    );
};

export { RequestAccess };
